import { createFileRoute } from "@tanstack/react-router";
import { MexicoHub } from "@/components/country/mx/MexicoHub";
import { CountrySwitcher } from "@/components/country/CountrySwitcher";

export const Route = createFileRoute("/mexico/")({
  head: () => ({
    meta: [
      { title: "VerseSport México — La casa del Tri en el Mundial 2026" },
      { name: "description", content: "Predicciones, porra del Tri, ranking de la Selección Mexicana, rivalidades por estado y comunidad para vivir el Mundial 2026. Compatible con TUDN, TV Azteca y Televisa Deportes." },
      { name: "keywords", content: "Selección Mexicana, Tri, Mundial 2026, pronósticos México, porra del Tri, TUDN, TV Azteca, Televisa Deportes" },
      { property: "og:title", content: "VerseSport México — La casa del Tri 🇲🇽" },
      { property: "og:description", content: "Pronostica, arma porra y representa a México en el Mundial 2026." },
      { property: "og:url", content: "https://versesport.com/mexico" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "es_MX" },
      { property: "og:image", content: "https://versesport.com/og/mexico.jpg" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "VerseSport México — La casa del Tri 🇲🇽" },
      { name: "twitter:description", content: "Pronostica, arma porra y representa a México en el Mundial 2026." },
      { name: "twitter:image", content: "https://versesport.com/og/mexico.jpg" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/mexico" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "VerseSport México",
          url: "https://versesport.com/mexico",
          inLanguage: "es-MX",
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SportsOrganization",
          name: "VerseSport México",
          url: "https://versesport.com/mexico",
          sport: "Soccer",
          areaServed: { "@type": "Country", name: "Mexico" },
          sameAs: ["https://t.me/versesport_mexico"],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            { "@type": "Question", name: "¿Cómo predigo los partidos del Tri en VerseSport?", acceptedAnswer: { "@type": "Answer", text: "Entra a /mexico, toca 'Pronostica el partido del Tri' y manda tu pronóstico antes del silbatazo inicial." } },
            { "@type": "Question", name: "¿Cómo armo porra con mi estado?", acceptedAnswer: { "@type": "Answer", text: "Elige tu estado en el ranking nacional y aparecerás representando a esa afición en cada acción que hagas." } },
            { "@type": "Question", name: "¿Funciona con TUDN, TV Azteca o Televisa?", acceptedAnswer: { "@type": "Answer", text: "Sí. VerseSport es segunda pantalla: ves el partido en tu canal favorito y juegas en paralelo con Audio Sync." } },
            { "@type": "Question", name: "¿Cuesta algo participar?", acceptedAnswer: { "@type": "Answer", text: "No. Predecir, armar porra y compartir es gratis. Hay beneficios extra opcionales para usuarios premium." } },
          ],
        }),
      },
    ],
  }),
  component: MexicoLanding,
});

function MexicoLanding() {
  return (
    <main className="mx-auto max-w-3xl space-y-4 px-3 py-4">
      <div className="flex items-center justify-end"><CountrySwitcher /></div>
      <MexicoHub />
    </main>
  );
}